// extracted by mini-css-extract-plugin
export default {"adminLayout_logo":"SideBar_adminLayout_logo__BwBBl","logo_unCollapsed":"SideBar_logo_unCollapsed__uhAHT","sidebar_container":"SideBar_sidebar_container__KfvO0"};